import React from "react";
import "../App.css";
import "../sections/Education.css";
import educationData from "../data/education.json";

const Education = () => (
  <section id="education" className="education-section">
    <h1 id="education-header">Education</h1>

    <div className="education-tiles">
      {educationData.map((item, index) => (
        <div className="education-card" key={index}>
          <div className="education-card-header">
            <h3 className="title">{item.title}</h3>
            <span className="years">{item.years}</span>
          </div>
          <h4 className="institution">{item.institution}</h4>
          <p className="description">{item.description}</p>
        </div>
      ))}
    </div>
  </section>
);

export default Education;
